<template>
  <div class="home">
    <Logo :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information flex-container2">
          <div class="flex">
            <div
              class="item flex-1"
              style="display: flex; justify-content: center"
            >
              <div class="card">
                <div class="title">
                  <span><b>監察院</b><br />公職人員財產申報網站</span>
                </div>
                <div class="txt"></div>
                <p class="f_center">
                  <strong>
                    <router-link to="/BackStage/Cy/Login">
                      <input type="submit" class="btn" value="進入本網站" />
                    </router-link>
                  </strong>
                </p>
                <ul class="linkUl">
                  <li>
                    <a href="#"
                      >客服專線：(02)2341-3183 分機:495 &nbsp;&nbsp;
                      傳真:(02)2341-2650</a
                    >
                  </li>
                  <br />
                  <li><a href="#"></a></li>
                  <br />
                  <li><a href="#"></a></li>
                </ul>
              </div>
              <div class="card">
                <div class="title">
                  <span><b>法務部</b><br />公職人員財產申報網站</span>
                </div>
                <div class="txt"></div>
                <p class="f_center">
                  <strong>
                    <router-link to="/BackStage/Pdis/Login">
                      <input type="submit" class="btn" value="進入本網站" />
                    </router-link>
                  </strong>
                </p>
                <ul class="linkUl">
                  <li>
                    <a href="#">客服專線：(02)2314-1000 (分機 2190 &amp; 2191 &amp; 2255) 傳真：(02)2381-6077</a>
                  </li>
                  <br />
                  <li>
                    <a href="mailto:aac2190@mail.moj.gov.tw">電子郵件信箱：aac2190@mail.moj.gov.tw</a>、
                    <a href="mailto:aac2191@mail.moj.gov.tw">aac2191@mail.moj.gov.tw</a>、
                    <a href="mailto:aac2255@mail.moj.gov.tw">aac2255@mail.moj.gov.tw</a>
                  </li>
                  <br />
                  <li><a href="#">客服時間：週一至週五 09:00-18:00</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Common/Logo.vue";

export default {
  name: "Home",
  data() {
    return {
      pageData: {
        ServiceUnit: "",
      },
    };
  },
  components: {
    Logo,
  },
};
</script>

<style scoped>
.icon_haiImgGreen {
  display: none;
}

.main-menu li .icon_haiImg {
  display: none;
}

.main-menu li.curent .icon_haiImgGreen {
  display: block;
}

.fontSize {
  right: 0;
  position: absolute;
  display: flex;
  top: 10px;
  z-index: 3;
}

.fontSize li {
  list-style: none;
  cursor: pointer;
  color: #303030;
  padding: 10px;
  font-size: 14px;
}

.size {
  border: 1px solid #303030;
  margin-right: 10px;
  display: grid;
}

.size:hover {
  background-color: #303030;
  color: #fff;
}

.size.current {
  background-color: #303030;
  color: #fff;
}

@media all and (max-width: 1000px) {
  .fontSize {
    top: 70px;
    right: 0;
  }

  .fontSize .size {
    padding: 7px;
  }
}

.card {
  width: 100%;
  max-width: 630px;
  box-sizing: border-box;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  background-color: white;
  margin: 20px 5px;
  border-radius: 10px;
}

.title {
  color: #fff;
  text-align: center;
  padding: 60px 30px;
  font-size: 1.8em;
  font-weight: bolder;
  position: relative;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
}

.title::before {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.3);
}

.title::after {
  position: absolute;
  left: 13px;
  top: 13px;
  content: "";
  display: block;
  border: 1px solid #fff;
  width: calc(100% - 26px);
  height: calc(100% - 26px);
}

.title span {
  position: relative;
}

.card:nth-child(1) .title {
  /* background-color: #c6e57f; */
  background-image: url("../assets/img/bg1.jpg");
  background-position: center center;
  background-size: cover;
}

.card:nth-child(2) .title {
  background-color: #84dbca;
  background-image: url("../assets/img/bg2.jpg");
  background-position: center center;
  background-size: cover;
}

.card:nth-child(3) .title {
  background-color: #6a9adb;
}

.card:nth-child(4) .title {
  background-color: #6553ce;
}

.card:nth-child(5) .title {
  background-color: #af5cd5;
}

.card:nth-child(6) .title {
  background-color: #d5765c;
}

.txt {
  font-size: 15px;
  padding: 20px;
  box-sizing: border-box;
  color: #303030;
  line-height: 24px;
}

.txt-1 {
  text-align: center;
  font-size: 15px;
  padding: 20px;
  box-sizing: border-box;
  color: #303030;
  line-height: 24px;
}

.txt-2 {
  text-align: center;
  font-size: 15px;
  padding: 20px;
  box-sizing: border-box;
  color: #303030;
  background-color: #6553ce;
  line-height: 24px;
}

.loginBtn {
  display: block;
  width: 90%;
  margin: 0 auto;
  border-radius: 5px;
  background-color: #0073b7;
  font-size: 16px;
  padding: 15px 0;
  text-align: center;
  color: #fff;
  text-decoration: none;
}

.linkUl {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 0;
}

.linkUl li {
  margin-right: 15px;
  list-style: none;
  display: inline-block;
}

.linkUl li a {
  color: #1e97e3;
  font-size: 16px;
  margin-bottom: 10px;
}

dd:first-child {
  margin-top: 10px;
  border-top: solid 1px #efefef;
}

dd p:last-child {
  font-weight: bold;
  font-size: 0.9em;
}

#two_column dd p:last-child a {
  line-height: 24px;
}

.title b {
  font-size: 50px;
}
</style>


